module.exports = __webpack_public_path__ + "img/ishong.3e81655c.jpeg";